(function () {
  const { Component } = window;

  const style = `
    :host {
      --facetFont: var(--font-label-md, 14px/1.4 sans-serif);
      --facetTextColor: var(--neutral-000, #fff);

      --facetBgColor: var(--neutral-600, #121212);
      --facetBorderColor: var(--neutral-400, #2A2A2A);

      --facetHoverBgColor: var(--neutral-500, #3a3a3a);
      --facetHoverBorderColor: var(--neutral-500, #1e1e1e);

      --facetFocusRingColor: var(--blue-400, #3478c1);

      --facetSelectedBorderColor: var(--blue-400, #3478c1);
      --facetSelectedBgColor: var(--blue-600, #17212c);
      --facetSelectedTextColor: var(--neutral-000, #fff);

      display: inline-block;
      box-sizing: border-box;
    }

    :host([hidden]) { display: none; }

    .option {
      appearance: none;
      background: var(--facetBgColor);
      border: 1px solid var(--facetBorderColor);
      border-radius: 8px;
      color: var(--facetTextColor);
      cursor: pointer;
      font: var(--facetFont);
      padding: 10px 16px;
      transition: background 0.15s ease, border-color 0.15s ease;
      white-space: nowrap;
      user-select: none;
    }

    .option:hover {
      background: var(--facetHoverBgColor);
      border-color: var(--facetHoverBorderColor);
    }

    .option:focus-visible {
      outline: 2px solid var(--facetFocusRingColor);
      outline-offset: 2px;
    }

    :host([selected]) .option {
      background: var(--facetSelectedBgColor);
      border-color: var(--facetSelectedBorderColor);
      color: var(--facetSelectedTextColor);
    }

    @media (prefers-reduced-motion: reduce) {
      .option { transition: none; }
    }
  `;

  const template = document.createElement('template');
  template.innerHTML = `
    <style>${style}</style>
    <button class="option" role="radio" aria-checked="false" type="button">
      <slot></slot>
    </button>
  `;

  class FilterFacet extends Component {
    static get observedAttributes() {
      return ['selected', 'value', 'label'];
    }

    static get propsCamelConventionEnabled() {
      return true;
    }

    constructor() {
      super();
      this.initBool(['selected']);
    }

    connectedCallback() {
      this._btn = this.select('.option');
      this.attachEvent(this._btn, 'click', this._onClick);
      this._syncAria();
    }

    template() {
      return template;
    }

    _onClick() {
      const wasSelected = this.selected;
      this.selected = !wasSelected;
      this._syncAria();

      this.dispatchEvent(new CustomEvent('filter-facet-change', {
        bubbles: true,
        composed: true,
        detail: {
          value: this.value,
          selected: this.selected
        }
      }));
    }

    _attributeSelected() {
      this._syncAria();
    }

    _syncAria() {
      if (!this._btn) {
        return;
      }
      this._btn.setAttribute('aria-checked', String(this.selected === true));
    }
  }

  if (!window.customElements.get('filter-facet')) {
    window.customElements.define('filter-facet', FilterFacet);
  }

  /* istanbul ignore next */
  if (typeof module !== 'undefined') {
    module.exports = FilterFacet;
  }
})();
